import React, { useEffect, useState } from "react";
import * as BiIcons from "react-icons/bi";
import moment from "moment";

const TableItemComponent = ({
  scheduleData,
  showAction,
  onSelectionChange,
}) => {
  const [rows, setRows] = useState([]);
  const [checkedAll, setCheckedAll] = useState(false);

  useEffect(() => {
    const selectedIds = rows.filter((r) => r.isChecked).map((r) => r.matchId);

    onSelectionChange?.(selectedIds);
  }, [rows, onSelectionChange]);

  useEffect(() => {
    if (!Array.isArray(scheduleData)) return;

    const flattened = [];

    scheduleData.forEach((day) => {
      const wrapper = day.scheduleAdWrapper;

      wrapper?.matchScheduleList?.forEach((series) => {
        series.matchInfo?.forEach((match) => {
          flattened.push({
            ...match,
            seriesName: series.seriesName,
            seriesId: series.seriesId,
            seriesCategory: series.seriesCategory,
            scheduleDate: wrapper.date,
            isChecked: false,
          });
        });
      });
    });

    setRows(flattened);
  }, [scheduleData]);

  const handleCheckAll = () => {
    const updated = rows.map((r) => ({
      ...r,
      isChecked: !checkedAll,
    }));
    setRows(updated);
    setCheckedAll(!checkedAll);
  };

  const handleCheckRow = (index) => {
    const updated = rows.map((r, i) =>
      i === index ? { ...r, isChecked: !r.isChecked } : r,
    );
    setRows(updated);
    setCheckedAll(updated.every((r) => r.isChecked));
  };

  return (
    <div>
      <table className="table table-bordered" width="100%">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                checked={checkedAll}
                onChange={handleCheckAll}
              />
            </th>
            {showAction && <th>Action</th>}
            <th>Date</th>
            <th>Match ID</th>
            <th>Series</th>
            <th>Category</th>
            <th>Match</th>
            <th>Format</th>
            <th>Teams</th>
            <th>Venue</th>
            <th>Start Time</th>
          </tr>
        </thead>

        <tbody>
          {rows.map((match, index) => (
            <tr key={`${match.matchId}-${match.seriesId}-${match.startDate}`}>
              <td>
                <input
                  type="checkbox"
                  checked={match.isChecked}
                  onChange={() => handleCheckRow(index)}
                />
              </td>
              <td></td>
              <td>{match.scheduleDate}</td>
              <td>{match.matchId}</td>
              <td>{match.seriesName}</td>
              <td>{match.seriesCategory}</td>
              <td>{match.matchDesc}</td>
              <td>{match.matchFormat}</td>
              <td>
                {match.team1.teamName} vs {match.team2.teamName}
              </td>
              <td>
                {match.venueInfo.ground}, {match.venueInfo.city}
              </td>
              <td>
                {moment(Number(match.startDate)).format("DD-MM-YYYY hh:mm A")}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableItemComponent;
